export default __webpack_public_path__ + "static/mysql-80505e1817002993c10468141877436b.png";